import React from 'react';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { Select } from '../../../atoms/Inputs/Select';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { sanitizeCalculToString } from '../../../../helpers/number/sanitizeCalul';
import { ProductTypes } from '../../../../types/product/product';
import { CarouselTag } from 'components/molecules/Carousel/CarouselTag';
import { CarouselTags } from 'components/molecules/Carousel/CarouselTags';
import useStyle from './singleProductPresentation.style';
import { ProductCarousel } from 'components/atoms/Product/ProductCarousel';

interface SingleProductPresentationViewProps {
  produit: ProductTypes;
  handleChange: (e) => void;
  handleSubmit: () => void;
  disabled: boolean;
  value: number;
}

export const SingleProductPresentationView = ({
  produit,
  handleChange,
  handleSubmit,
  disabled,
  value
}: SingleProductPresentationViewProps) => {
  const classes = useStyle();
  const productTag = produit?.categorieproduits;

  return (
    <FeatureContainer>
      <div className={classes.root}>
        <div className={classes.image}>
          <ProductCarousel
            productName={produit.name}
            productMedia={produit.media}
          />
        </div>
        <div>
          <p className={classes.name}>{produit?.name}</p>
          <div className={classes.carousel}>
            {productTag.length > 1 && <CarouselTags tags={productTag} />}
            {productTag.length === 1 && <CarouselTag tag={productTag[0]} />}
          </div>
          <p className={classes.infos}>
            {sanitizeCalculToString(produit?.ttcPrice)}€ TTC - Poids net{' '}
            {produit?.netWeight} g
          </p>
          <p className={classes.infos}>{produit?.description}</p>
          <div className={classes.actions}>
            <Select
              maxValue={1000}
              onChange={e => handleChange(e)}
              value={value}
            />
            <ButtonWithText
              disabled={disabled}
              content={'Ajouter au panier'}
              variant={'secondaryBlue'}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </FeatureContainer>
  );
};
